import { useCallback } from 'react';

import { Tasks } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { type GetBaseMetadata, type LibraryRestorationTask } from '~/store/tasks/types';
import { useCreateTask } from '~/utils/taskUtils/useCreateTask';

export type CreateLibraryRestorationTaskParams = GetBaseMetadata<LibraryRestorationTask>;

export const useLibraryRestorationTask = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { createTask } = useCreateTask();

  const createLibraryRestorationTask = useCallback(
    ({ libraryId, title }: CreateLibraryRestorationTaskParams) => {
      const workspaceId = currentWorkspace?.id;
      if (!workspaceId) {
        throw new Error('No workspace id');
      }
      return createTask({
        task: {
          metadata: { libraryId, title },
          type: 'LibraryRestoration',
        },
        createTask: () =>
          Tasks.createTask({
            workspaceId,
            task: {
              type: 'ContentRestorer',
              args: { libraryId, title },
            },
          }),
      });
    },
    [createTask, currentWorkspace?.id],
  );

  return { createLibraryRestorationTask };
};
